import React, { useEffect, useState, useRef } from "react";
import BreadCrumb from "./BreadCrumb";
import LinkSection from "./Linksection";
import 'animate.css';

const FlyOut = ({linkChildren, crumbItem, handleClose, navData, callRightToLeftAnimation, naviOpen, activePageId, activeNavRootId, navPathIds, tabIndex, closeFlyoutRef, dictionary}: any) => {
  const [childrenDataVar, setChildrenDataVar] = useState({});
  const [breadCrumb, setBreadCrumb] = useState<any[]>([]);
  const [ani, setAni] = useState('');
  const [teaserData, setTeaserData] = useState({});
  const activeNavCrumbs:any[] = [];
  const firstFlyoutLinkRef = useRef<HTMLAnchorElement>(null);
  const setLeftAnimation = () => {
    setAni("animate__fadeInLeft");
  }

  const setRightAni = () => {
    setAni("animate__fadeInRight");
  }

  const focusFirstFlyoutLink = () => firstFlyoutLinkRef.current && firstFlyoutLinkRef.current.focus();

  // find navigation node element in nested object
  const findActiveNavNode:any = () => {
    let navParent;
    if(navPathIds.length > 0 && navPathIds[0] === activeNavRootId){
      let navChildren = navData;
      for(let i = 0; i < navPathIds.length; i++){
        if(navChildren.length > 0){
          const foundNavNode = navChildren.find(
            (jsonNavNode:any) =>
            {return jsonNavNode.id === navPathIds[i]});
          if(foundNavNode !== undefined && foundNavNode.children !== undefined && foundNavNode.children.length > 0){
            navChildren = foundNavNode.children;
            navParent = foundNavNode;
            activeNavCrumbs.push(navParent);
          }
        }
      }
    }
    return navParent;
  }
    // check for teaser data
  const checkForTeaser = (dataRef:any) => {
    if(dataRef.teaser !== undefined){
      setTeaserData(dataRef.teaser);
    }else{
      setTeaserData({});
    }
  }

  // load data for flyout and prepare breadcrumbs
  const searchChildrenData = (backData = undefined) => {
    if(backData !== undefined) {
      const newBackData = [...backData!];
      setChildrenDataVar(newBackData);
    } else{
      //check if page ist in the active Navroot
      const activeNavData = findActiveNavNode();
      if(activeNavData !== undefined  && activeNavData.children.length > 0){
        setChildrenDataVar(activeNavData.children);
        // check for teaser data
        checkForTeaser(activeNavData);
      }else{
        navData.map((nodeData: any) => {
          if(nodeData.id === linkChildren.id){
            if(nodeData.children){
              setChildrenDataVar(nodeData.children);
            }
            // check for teaser data
            checkForTeaser(nodeData);
          }
        });
      }
    }
    //check active bread crumbs on loading
  }

  // check if data is coming from main or from breadcrumb
  const backDataFromBreadcrumb = (data:any) => {
    if(data.children){
      searchChildrenData(data.children);
    }

    // check for teaser data
    checkForTeaser(data);
  }

  // prepare for breadcrumb
  const breadCrumbChange = (crumb:any) => {
    if(activeNavCrumbs.length > 0){
      setBreadCrumb(activeNavCrumbs);
    }else{
      setBreadCrumb([crumb] as any);
    }
  }

  // prepare for flyout items
  const breadCrumbChangeChild = (crumb:any) => {
    setChildrenDataVar(crumb);
    setBreadCrumb(prevArray => [...prevArray, crumb] as any);
  }

  // close icon click listener
  const closeIconClick = () => {
    // set data to reset
    const obj = breadCrumb[breadCrumb.length - 1] as any;
    setChildrenDataVar([...obj.children]);

    // call parent close function
    handleClose();
  }

  // go one bread crumb item back
  const oneItemBack = () => {
    // remove last item from array
    const tempBreadCrumb = [...breadCrumb];
    tempBreadCrumb.pop();


    // get new last item from array
    const obj = tempBreadCrumb[tempBreadCrumb.length - 1] as any;
    setChildrenDataVar(obj.children);
    setBreadCrumb(tempBreadCrumb);

    // check for teaser data
    checkForTeaser(obj);
    focusFirstFlyoutLink();
    setLeftAnimation();
  }

  const flyoutBackLink = () => {
    return <a
      href='#'
      className='link flyout_back_link'
      id='flyout-back-link'
      aria-label={dictionary["nav.flyoutback"] || "Ebene zurück"}
      onClick={() => {
        oneItemBack()
      }}
      role="button"
      tabIndex={tabIndex}
    >
      <span className='ic-arrowLeft' aria-hidden='true'/>
      {dictionary["nav.flyoutback"] || "Ebene zurück"}
    </a>
  }

  const flyoutCloseLink = () => {
    return <a
      ref={closeFlyoutRef}
      href="#"
      data-section="main-navi_close_desktop"
      className="js-flyout-close nav__close"
      aria-label={dictionary["nav.labelflyoutclose"] || "Navigation schließen"}
      role="button"
      onClick={closeIconClick}
      tabIndex={tabIndex}
    >
      <span className="ic-close" aria-hidden="true" title={dictionary["nav.labelflyoutclose"] || "Navigation schließen"}/>
    </a>
  }

  useEffect(() => {

    // slide from right
    if(naviOpen) {
      callRightToLeftAnimation.current = setRightAni;
    }

    return () => {
      callRightToLeftAnimation.current = null;
    };
  },[]);

  // set Animation
  const setAnimation = (animation: any) => {
    setAni(animation);
  }

  // refresh flyout and flyout breadcrumb
  useEffect(() => {
    searchChildrenData();
    breadCrumbChange(crumbItem);
    // clear animation when changing tabs
    if (!crumbItem.length || crumbItem.length === 0) {
      setAni('');
    }
  }, [setChildrenDataVar, crumbItem, linkChildren]);
  return (
    <div
      className={`nav-primary-panel positioning`}
      id="js-nav-primary-panel"
      data-state={`${crumbItem.length === 0 ? "closed" : "open"}`}
      aria-hidden={naviOpen ? 'false' : 'true'}
    >
      <div className='nav-primary-panel__inner'>
        <div className='l-container'>
          <div className='nav'  aria-label="Flyout Navigation">
            <div className='nav__toprow' aria-label="Breadcrumb">
              <div className="breadcrumb" data-module="flyout-breadcrumb,flyout-breadcrumb-shortener" aria-hidden="true">
                <span className="link nav__home-link">Startseite</span>
                <span className="ic-arrowRight main-navi__breadcump-separator" aria-hidden="true"/>
                <BreadCrumb
                  crumbs={breadCrumb}
                  flyoutFunction={backDataFromBreadcrumb}
                  setAnimation={setAnimation}
                  navData={navData}
                  tabIndex={tabIndex}
                />
              </div>

            </div>
            <div className="nav__wrapper js-nav-wrapper u-clearfix">
              {naviOpen &&
                <LinkSection
                  linkSectionData={childrenDataVar}
                  crumbsFunction={breadCrumbChangeChild}
                  animation={ani} setRightAni={setRightAni}
                  teasDaRe={teaserData}
                  activePageId={activePageId}
                  tabIndex={tabIndex}
                  firstFlyoutLinkRef={firstFlyoutLinkRef}
                  focusFirstFlyoutLink={focusFirstFlyoutLink}
                  dictionary={dictionary}
                />
              }
              {breadCrumb.length > 1 && flyoutBackLink()}
              {flyoutCloseLink()}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default FlyOut;
